export const FieldTypes = {
    checkbox: ['checkbox'],
    input: [
        'text',
        'button',
        'color',
        'date',
        'datetime-local',
        'email',
        'file',
        'hidden',
        'image',
        'month',
        'number',
        'password',
        'radio',
        'range',
        'reset',
        'search',
        'submit',
        'tel',
        'time',
        'url',
        'week'
    ],
    select: ['select']
}
export class FieldApparence {
    fullwidth: boolean;
    isNarrow: boolean;
    min: number;
    constructor({
        fullwidth = false,
        isNarrow = false,
        min = 0,
    }) {
        this.fullwidth = fullwidth;
        this.isNarrow = isNarrow;
        this.min = min;
    }
}
export class FieldValidation {
    min: Number;
    max: Number;
    required: boolean;
    constructor({
        min = null,
        max = null,
        required = true
    }) {
        this.min = min;
        this.max = max;
        this.required = required;
    }
}
export interface FieldSettings {
    apparence?: FieldApparence;
    validation?: FieldValidation;
    onChange?: Function;
    removeOnSave?: boolean;
}
export default class Field implements FieldSettings {
    public apparence: FieldApparence;
    public validation: FieldValidation;
    public onChange: Function;
    public removeOnSave: boolean;
    constructor(
        public name: string = 'name',
        public type: string = 'text',
        settings: FieldSettings =
            {
                apparence: new FieldApparence({ fullwidth: false }),
                validation: new FieldValidation({ required: true }),
                onChange: null,
                removeOnSave: false
            }
    ) {
        this.apparence = settings.apparence;
        this.validation = settings.validation;
        this.onChange = settings.onChange;
        this.removeOnSave = settings.removeOnSave;
    }
}


// WEBPACK FOOTER //
// ./client/components/simpleCrud/field.class.ts